// import axiosIns from 'utils/axios'
import { service as axiosIns } from '../utils/axios';

// // 医生与患者关系的建立与删除
// export function createDoctorIllRelation(params) {
//     return axiosIns({
//         url: `/doctor/addAndDelete`,
//         method: 'get',
//         params: params
//     })
// }




// 生成回调url
export function generateOauthPageUrl(data) {
    return axiosIns({
        url: `/weixinAuthApi/generateOauthPageUrl`,
        method: 'post',
        data
    })
}


// 微信用户授权登录
export function userAuth(data) {
    return axiosIns({
        url: `/weixinAuthApi/userAuth`,
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/weixin.js